<template>
  <div>
    <div style="height:3rem"></div>
    <el-form style="padding-left:10%;padding-right:10%" :model="reg" :rules="regRules" ref="regtable">
      <el-row type="flex" justify="center">
        <el-form-item prop="name" class="user_input">
            <el-input :placeholder="user_info.name" v-model="reg.name"><span slot="prepend" >姓名：</span></el-input>
        </el-form-item>
      </el-row>
      <el-row type="flex" justify="center">
        <el-form-item prop="age" class="user_input">
          <el-input :placeholder="user_info.age" type="number" min=1 v-model="reg.age"><span slot="prepend" >年龄：</span></el-input>
        </el-form-item>
      </el-row>
      <el-row type="flex" justify="center">
        <el-form-item prop="phone" class="user_input">
          <span></span><el-input  :placeholder="user_info.phone" v-model="reg.phone"><span slot="prepend" >手机号：</span></el-input>
        </el-form-item>
      </el-row>
      <el-row type="flex" justify="center">
        <el-form-item prop="id_number" class="user_input">
         <el-input  :placeholder="user_info.id_number" v-model="reg.id_number"><span slot="prepend" >身份证：</span></el-input>
        </el-form-item>
      </el-row>
      <el-row type="flex" justify="space-around">
        <el-form-item prop="pwd" class="user_input">
          <el-input placeholder="********" v-model="reg.pwd" show-password><span slot="prepend" >修改密码：</span></el-input>
        </el-form-item>
      </el-row>
      <el-row type="flex" justify="space-around">
        <el-form-item prop="secondaryPwd" class="user_input">
          <el-input placeholder="" v-model="secondaryPwd" show-password><span style="width: 2rem" slot="prepend" >确认密码：</span></el-input>
        </el-form-item>
      </el-row>
<!-- 2022/08-09 去除该项功能 学员自主修改岗位会导致问题-->
<!--<el-row type="flex" justify="center">
        <el-form-item prop="station_id" class="user_input">
          <el-cascader style="width: 100%;"
          v-model="arrs"
          :options="gmdss.optionsList">
          </el-cascader>
        </el-form-item>
      </el-row>-->
      <el-row type="flex" justify="center">
        <el-form-item prop="is_onShip" class="user_input">
          <el-select style="width: 100%;"  v-model="reg.is_onShip">
            <el-option
              v-for="item in onShipOptions "
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row type="flex" justify="center">
        <el-form-item prop="serve_ship" class="user_input">
          <el-select style="width: 100%;" clearable v-model="reg.serve_ship" :placeholder="'服务船舶：'+reg.ship_name">
            <el-option
              v-for="item in shipOptions "
              :key="item.id"
              :label="item.ship_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-row>
    </el-form>
    <el-row type="flex" justify="space-around">
        <div class="user_input">
          <div class="reg_btn" @click="regBtn">保存修改</div>
        </div>
         <div class="user_input">
          <div class="reg_btn" @click="back">返回</div>
        </div>
      </el-row>
  </div>
</template>
<script>
import * as req from '@/utils/request'

export default {
  data () {
    return {
      user_info: '',
      openid: '',
      secondaryPwd: '',
      logins: {
        id_number: '',
        pwd: ''
      },
      shipOptions: [],
      onShipOptions: [
        {
          value: false,
          label: '否'
        },
        {
          value: true,
          label: '是'
        }
      ],
      // 部门岗位
      arrs: [1, 1],
      reg: {
        // 身份证
        id_number: '',
        station: null,
        station_id: null,
        name: '',
        pwd: '',
        branch_id: 0,
        // 部门名字
        branch: '',
        serve_ship: null,
        age: null,
        // 是否在船
        is_onShip: null,
        phone: null
      },
      // 修改数据验证
      regRules: {
        name: [
          // { required: true, trigger: 'blur', message: '请输入用户名' },
          {min: 1, max: 30, pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9_]{1,30}$/, message: '请输入用户名, 限中英文数字,不超过30'}
        ],
        id_number: [
          // { required: true, trigger: 'blur', message: '请输入身份证号' },
          {min: 18, max: 18, pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请输入正确格式的身份证号'}
        ],
        age: [
          // { required: true, trigger: 'blur', message: '请输入年龄' },
          {pattern: /^(?:[1-9][0-9]?|1[01][0-9]|120)$/, message: '请输入正确格式的年龄'}
        ],
        phone: [
          // { required: true, trigger: 'blur', message: '请输入手机号' },
          {pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确格式的手机号'}
        ],
        station_id: [
          // { required: true, message: '请选择岗位', trigger: ['blur', 'change'] }
        ],
        serve_ship: [
          // { required: true, message: '请选择服务的船舶', trigger: 'change' }
        ],
        pwd: [
          // {required: true, trigger: 'blur', message: '请输入密码'},
          { min: 8, max: 16, pattern: /^[0-9a-zA-Z]{8,16}$/, message: '密码格式错误, 长度8到16字符,包含大小写字母和数字', trigger: 'blur' }
        ]
      },
      // 所有部门
      branchList: [],
      // 岗位列表
      stationList: [],
      // 选项数组
      optionsList: []
    }
  },
  mounted () {
    this.getStationList()
    this.getShipList()
  },
  created () {
    this.user_info = this.gmdss.user_info
    this.user()
    this.branch_name()
    this.getStationList()
    this.getShipList()
  },
  methods: {
    back () {
      window.history.back()
    },
    user () {
      if (this.user_info === undefined) {
        this.reg.is_onShip = ''
        this.reg.ship_name = ''
      } else {
        this.reg.is_onShip = '是否在船:' + this.$route.query.user.is_onShip
        this.reg.age = this.user_info.age
        this.reg.phone = this.user_info.phone
        this.reg.ship_name = this.$route.query.user.ship_name
        this.arrs[0] = this.user_info.branch_id
        this.arrs[1] = this.user_info.station_id
      }
      // 获取部门和岗位
      // this.gmdss.user_info = this.user_info
      this.station_name()
    },
    getLink () {
      let code = null
      let url = window.location.href
      let index = url.indexOf('code=')
      if (index !== -1) {
        let str = url.substring(index + 5, url.length - 1)
        code = str.split('&')[0]
      }
      return code
    },
    station_name () {
      for (let i in window.$gmdss.stationList) {
        if (this.user_info.station_id === window.$gmdss.stationList[i].id) {
          this.station = window.$gmdss.stationList[i].station
          window.$gmdss.station = this.station
          console.log(window.$gmdss.station)
          return this.station
        }
      }
    },
    // 修改验证
    regBtn () {
      this.$refs.regtable.validate((valid) => {
        if (valid) {
          if (this.reg.name === '') {
            this.reg.name = this.user_info.name
          }
          // if (!this.reg.station || !this.reg.station_id) {
          //   this.$message.error('部门岗位不能为空')
          //   return
          // }
          if (!this.reg.age || this.reg.age === '') {
            if (!this.user_info.age) {
              this.$message.warning('年龄不能为空')
              return
            }
            this.reg.age = this.user_info.age
          }
          if (this.reg.id_number === '' || this.reg.id_number === undefined) {
            this.reg.id_number = undefined
          } else {
            let sendData = {}
            let msg = {}
            msg.id_number = this.gmdss.user_info.id_number
            msg.user_id = this.reg.id_number
            sendData.data = msg
            sendData.fn = this.updateOpenidfn
            sendData.vm = this
            req.Post('user/updateOpenid', sendData)
            this.gmdss.user_info.id_number = this.reg.id_number
          }
          if ([null, '', 'null'].includes(this.reg.phone)) {
            if ([null, '', 'null'].includes(this.user_info.phone)) {
              this.$message.error('手机号不能为空')
              return
            }
            this.reg.phone = this.gmdss.user_info.phone
          }
          if (this.reg.pwd === '' || this.reg.pwd === undefined) {
            this.reg.pwd = undefined
            this.secondaryPwd = undefined
          } else {
            if (this.secondaryPwd !== this.reg.pwd) {
              this.$message('两次密码不一致, 请重新输入')
              this.secondaryPwd = ''
              this.reg.pwd = ''
              return
            } else {
              this.reg.pwd = this.$md5(this.reg.pwd)
            }
          }
          if (this.reg.serve_ship === null) {
            this.reg.serve_ship = this.user_info.serve_ship
          } else {
            window.$gmdss.user_info.serve_ship = this.reg.serve_ship
          }
          if (this.reg.station_id === null || this.reg.station_id === undefined) {
            this.reg.branch_id = 1
            this.reg.station_id = 1
          } else {
            this.reg.branch_id = this.arrs[0]
            this.reg.station_id = this.arrs[1]
            window.$gmdss.user_info.branch_id = this.reg.branch_id
            window.$gmdss.user_info.station_id = this.reg.station_id
          }
          if (this.reg.is_onShip === false) {
            this.reg.is_onShip = 0
            window.$gmdss.user_info.is_onShip = '否'
          } else {
            this.reg.is_onShip = 1
            window.$gmdss.user_info.is_onShip = '是'
          }
          this.reg.id = this.user_info.id
          if (this.reg.age === '') {
            this.reg.age = this.user_info.age
          }
          // 提交修改
          this.submitReg()
        } else {
          this.$message.error('请正确输入信息')
        }
      })
    },
    // 提交修改
    submitReg () {
      let sendData = {}
      sendData.data = this.reg
      sendData.fn = this.submitRegFn
      sendData.vm = this
      req.Post('user/update_UserData2', sendData)
    },
    // 修改回调
    submitRegFn (data) {
      if (data === null || data === undefined || data === '') {
        // this.resetForm('regForm')
        this.$message('服务器出错')
        return
      }
      if (data === 'repeat') {
        this.$message('身份证已被注册，修改失败')
        this.reg.is_onShip = '是否在船:' + window.$gmdss.user_info.is_onShip
        return
      }
      if (data.err_code !== 0) {
        // this.resetForm('regForm')
        this.$message(data.err_msg)
        return
      }
      this.$message({
        type: 'success',
        message: '修改成功, 请重新登录！',
        duration: 1000
      })
      this.secondaryPwd = ''
      this.reg.pwd = ''
      this.reg.is_onShip = '是否在船:' + window.$gmdss.user_info.is_onShip
      // window.history.back()
      this.$router.push('/')
    },
    // 修改openid
    updateOpenidfn (data) {
      if (data.err_code !== 0) {
        this.$message(data.err_msg)
      }
    },
    // 获取甲板name
    branch_name () {
      this.branchList = this.gmdss.branchList
      for (let i in this.branchList) {
        if (this.branchList[i].id === this.user_info.branch_id) {
          this.branch = this.branchList[i].branch
          return this.branch
        }
      }
    },
    // 获取岗位列表
    getStationList () {
      let sendData = {}
      sendData.data = null
      sendData.fn = this.getStationListFn
      sendData.vm = this
      req.Get('station/get_job', sendData)
    },
    getStationListFn (data) {
      if (data.err_code !== 0) {
        this.$message(data.err_msg)
        return
      }
      this.stationList = data.list
      let datas = this.getOptions()
      if (datas.length === 0) {
        return
      }
      this.gmdss.optionsList = datas
    },
    // 获取服务船舶列表
    getShipList () {
      let sendData = {}
      sendData.data = null
      sendData.fn = this.getShipListFn
      sendData.vm = this
      req.Get('ship/get_ship', sendData)
    },
    getShipListFn (data) {
      if (data.err_code !== 0) {
        this.$message(data.err_msg)
        return
      }
      this.shipOptions = data.list
    },
    // 生成部门和岗位选项
    getOptions () {
      let branchList = this.branchList
      let stationList = this.stationList
      let ary = []
      for (let i in branchList) {
        let obj = {}
        obj.value = branchList[i].id
        obj.label = branchList[i].branch
        let children = this.getChildren(branchList[i].id, stationList)
        if (children.length > 0) {
          obj.children = children
        }
        ary.push(obj)
      }
      return ary
    },
    // 根据部门id获取所属岗位
    getChildren (branchId, stationList) {
      let ary = []
      for (let i in stationList) {
        if (stationList[i].branch_id === branchId) {
          let obj = {}
          obj.value = stationList[i].id
          obj.label = stationList[i].station
          ary.push(obj)
        }
      }
      return ary
    }
  },
  // 路由进来前
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.user_info = vm.gmdss.user_info
      vm.branch_name()
      vm.getStationList()
      vm.getShipList()
      vm.user()
      vm.reg.station_id = ''
      vm.reg.name = ''
      vm.reg.age = ''
      vm.reg.phone = ''
      vm.reg.pwd = ''
      vm.secondaryPwd = ''
    })
  },
  // 路由跳出后
  beforeRouteLeave (to, from, next) {
    next()
  }
}
</script>

<style scoped>
.logo {
  bottom: 45%;
  /* position: absolute; */
  width: 100px;
  height: 80px;
  left: 38%;
  background-image: url(../assets/00.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  -o-background-size: cover;
  margin-top: 4rem;
}
.corporation{
  font-size: 18px;
  margin-top: 5px;
}
.corporation_title{
  color: #0084ff;
  font-size: 28px;
  margin-top: 5px;
}
.user_input{
  margin: 0.5rem;
  width: 20rem;
}
.login_btn{
  width: 100%;
  height: 50px;
  background-image: url(../assets/07.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  -o-background-size: cover;
  color: rgb(255, 255, 255);
  font-size: 22px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 30px;
  display: flex;
}
.reg_btn{
  margin:0 auto;
  margin-top: 2rem;
  width: 5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: rgb(64, 163, 255);
  text-align: center;
  color: #fff;
  border-radius: 7px;
  box-shadow: 2px 2px 1px rgb(45, 114, 178);
}
.bottom{
  position: absolute;
  bottom: -13rem;
  /* width: 100%; */
  font-size: 15px;
}
.gotoReg{
  margin-top: 2rem;
  color: #00aaff;
  cursor: pointer;
}
.input{
  text-align: center;
  width: 80%;
  float: right;
}
.el-input-group__prepend{
  width: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/edit.vue